module.exports = __webpack_public_path__ + "img/12.16394a14.jpg";